import React from 'react';
import { color, font } from '../constants';
import styled, { keyframes } from 'styled-components';
import { Container } from 'react-bootstrap';
import ReactLogo from '../imnages/logo192.png';

const HeroCont = styled.div`
  padding: 1rem;
  height: 90vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: .5rem;
  box-shadow: 2px 2px 2px rgba(0, 0, 0, .2),
              -2px -2px 2px rgba(255, 255, 255, .5);
  @media(min-width: 576px){
    //margin-top: 1rem;
  }
`
const Rotation = keyframes`
  to{
    transform: rotate(180deg);
  }
`
const HeroLogo = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 150px;
  height: 150px;
  border-radius: 50%;
  padding: .5rem;
  margin-bottom: 1rem;
  box-shadow: inset 2px 2px 2px rgba(0, 0, 0, .2),
              inset -2px -2px 2px rgba(255, 255, 255, .5);
`
const HeroImg = styled.img`
  width: 118px;
  height: 118px;
  object-fit: cover;
  object-position: center;
  animation: ${Rotation} 10s linear infinite;
`
const HeroTextCont = styled.div`
  user-select: none;
  width: 100%;
  margin-bottom: 2rem;
  border-radius: 1rem;
  padding: 1rem 2rem;
  box-shadow: inset 2px 2px 2px rgba(0, 0, 0, .2),
              inset -2px -2px 2px rgba(255, 255, 255, .5);
`
const Title = styled.h1`
  font-family: ${font.title};
  text-transform: uppercase;
  text-align: center;
  width: 100%;
  font-size: 5rem;
  margin: 0;
  line-height: 5rem;
`
const SubTitle = styled.p`
  text-align: center;
  margin: 0;
  text-transform: capitalize;
  color: ${color.prim};
  font-weight: bold;
`
const ButtonCont = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`
const Button = styled.a`
  background: transparent;
  color: #999;
  text-decoration: none !important;
  padding: .8rem;
  border: none;
  border-radius: .5rem;
  text-transform: uppercase;
  user-select: none;
  box-shadow: 2px 2px 2px rgba(0, 0, 0, .2),
              -2px -2px 2px rgba(255, 255, 255, .5);
  &:visited{
    color: #999;
  }
  &:hover{
    color: ${color.sec};
  }
  &:active{
    color: ${color.prim};
    font-weight: bold;
    box-shadow: inset 2px 2px 2px rgba(0, 0, 0, .2),
                inset -2px -2px 2px rgba(255, 255, 255, .5);
  }
`
export default ()=> {

  return(
    <Container>
      <HeroCont className="animated fadeIn delay-2s">
        <HeroLogo>
          <HeroImg src={ReactLogo} alt="react logo" />
        </HeroLogo>
        <HeroTextCont className="animated fadeIn delay-3s">
          <Title>raos</Title>
          <SubTitle>react animation on scroll</SubTitle>
        </HeroTextCont>
        <ButtonCont className="animated fadeInUp delay-4s">
          <Button href="#start">get started</Button>
          <Button href="#showcase" style={{ marginLeft: "1rem" }}>showcase</Button>
        </ButtonCont>
      </HeroCont>
    </Container>
  )
}
